import { render } from "./withdrawal-list.vue?vue&type=template&id=ebb577a8"
import script from "./withdrawal-list.vue?vue&type=script&lang=js"
export * from "./withdrawal-list.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\cbetta\\Desktop\\workspace\\hub-web-apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__